import posthog from 'posthog-js';

const isLocalhost = () => {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1' || host === '::1';
};

const getPostHogApiKey = () => (
  process.env.REACT_APP_POSTHOG_KEY
  || process.env.REACT_APP_PUBLIC_POSTHOG_KEY
  || process.env.NEXT_PUBLIC_POSTHOG_KEY
  || ''
).trim();

const getPostHogHost = () => (
  process.env.REACT_APP_POSTHOG_HOST
  || process.env.NEXT_PUBLIC_POSTHOG_HOST
  || 'https://us.i.posthog.com'
).trim();

const shouldAllowLocalhost = () => String(process.env.REACT_APP_POSTHOG_ALLOW_LOCALHOST || '').trim().toLowerCase() === 'true';

let hasInitialized = false;

export const initPostHog = () => {
  if (hasInitialized) return false;

  const apiKey = getPostHogApiKey();
  if (!apiKey) {
    console.warn('[PostHog] Missing API key. Set REACT_APP_POSTHOG_KEY.');
    return false;
  }

  if (isLocalhost() && !shouldAllowLocalhost()) {
    console.info('[PostHog] Skipping localhost capture (set REACT_APP_POSTHOG_ALLOW_LOCALHOST=true to enable).');
    return false;
  }

  try {
    posthog.init(apiKey, {
      api_host: getPostHogHost(),
      autocapture: true,
      capture_pageview: true,
    });

    hasInitialized = true;
    return true;
  } catch {
    // PostHog should fail silently.
    return false;
  }
};

export const identifyPostHogUser = (uid, email) => {
  if (!uid) return;

  try {
    initPostHog();
    if (!hasInitialized) return;

    posthog.identify(String(uid), {
      email: email || undefined,
    });
  } catch {
    // PostHog should fail silently.
  }
};

export const resetPostHogUser = () => {
  try {
    if (!hasInitialized) return;
    posthog.reset();
  } catch {
    // PostHog should fail silently.
  }
};
